import PropTypes from 'prop-types';
import React from 'react';

import { Card, Text, Title } from './styles';

const CardAviso = ({ title, children }) => (
  <Card>
    <Text>
      <Title>{title}</Title>
      &nbsp;
      {children}
    </Text>
  </Card>
);

CardAviso.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};
CardAviso.defaultProps = {
  title: '',
};

export default CardAviso;
